import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { AssemblyArtifact } from '../../models/artifact';
import { DxDataGridModule } from 'devextreme-angular';
import { DxoSelectionModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';

@Component({
    selector: 'app-assembly-artifact-grid',
    templateUrl: './assembly-artifact-grid.component.html',
    styleUrls: ['./assembly-artifact-grid.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxDataGridModule, DxoSelectionModule, DxiColumnModule, DxTemplateModule]
})
export class AssemblyArtifactGridComponent {
    artifacts = input<AssemblyArtifact[]>([]);

    calculateIsNewColumnValue(rowData: AssemblyArtifact) {
        return !rowData.ArtifactId;
    }
}
